export function isSystemMetric(metricName: string) {
  return metricName.startsWith('system/');
}
